import { Icon, Typography } from '#components';
import c from 'classnames';

import styles from './BackButton.module.css';

export type BackButtonVariants = 'button' | 'link';
export const BackButton = ({
  variant = 'button',
  goBack,
  className,
  testId,
}: {
  variant?: BackButtonVariants;
  goBack?: () => void;
  className?: string;
  testId?: string;
}) => {
  return (
    <div
      className={c(
        styles.back,
        variant === 'button' && styles.button,
        variant === 'link' && styles.link,
        className,
      )}
      onClick={goBack}
      data-testid={testId}
    >
      <Icon name='chevronBack' size='s' />
      {variant === 'link' && (
        <Typography variant='body-s' className='my-auto'>
          Back
        </Typography>
      )}
    </div>
  );
};
